import { Tooltip } from '@mantine/core';

export default function CreatedBy({ email }: { email: string }) {
  const emailPrefix = email?.split('@').at(0);
  return (
    emailPrefix && (
      <Tooltip label={email}>
        <div className="w-fit rounded-xl bg-indigo-300/20 p-1 px-3 text-xs font-medium text-indigo-500 first-letter:capitalize dark:text-indigo-300">
          {emailPrefix}
        </div>
      </Tooltip>
    )
  );
}
